import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';

import { MsalGuard } from '@azure/msal-angular';
import { AddVoucherV2Component } from '../app/add-voucher-v2/add-voucher-v2.component';
import { PageNotFoundComponent } from '../app/page-not-found/page-not-found.component';
import { VoidVoucherComponent } from '../app/void-voucher/void-voucher.component';
import { AddMarketingVouchersComponent } from './add-markerting-vouchers/add-marketing-vouchers.component';
import { ListVoucherComponent } from './list-voucher/list-voucher.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'add-cs-voucher',
    component: AddVoucherV2Component,
    canActivate: [MsalGuard]
  },
  {
    path: 'add-marketing-vouchers',
    component: AddMarketingVouchersComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'void-voucher',
    component: VoidVoucherComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'list-vouchers',
    component: ListVoucherComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: '**',
    redirectTo: '/home'
  }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
